import { render, staticRenderFns } from "./Admin_mentorias.vue?vue&type=template&id=5bd51258&"
import script from "./Admin_mentorias.vue?vue&type=script&lang=js&"
export * from "./Admin_mentorias.vue?vue&type=script&lang=js&"
import style0 from "./Admin_mentorias.vue?vue&type=style&index=0&id=5bd51258&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports